import React from "react";
import { Header,Popup,Icon } from "semantic-ui-react";   //add Popup and Icon
import { dispatch } from '@rematch/core';
import { source } from 'react-aim';

import DefinePracticeFlowTree from '../../drive/trees/Practiceflow/PracticeFlowTreePage'

@source({
    mouseEnter: () => {
        dispatch.app.setHelpContext("Community Tree")
    }
})
class CommunityTree extends React.Component {

    render() {

        return (
            <div>
                <Header floated='left'> Assignments</Header>
                {this.props.selectedPracticeLibrary.status == 0 ?
                <Popup
                    trigger={<Icon name="info icon blue circle" size="large"/>}
                    content="Right click to add a new group or a sub group"
                    basic
                    wide
                />:""} 
                <DefinePracticeFlowTree
                    className="practiceCommunity"
                    selectedPracticeLibrary={this.props.selectedPracticeLibrary}
                    user={this.props.user}
                    parent={this.props.selectedPracticeFlowCommunity.parentCommunity}
                    addAction={dispatch.lifeCycle.createCommunity}
                    deleteAction={dispatch.lifeCycle.deleteCommunity}
                    updateAction={dispatch.lifeCycle.updateCommunity}
                    resourcPane="CommunityFlow"
                    getSelection={dispatch.createPack.getSelectedCommunityAsync}
                    selectedPracticeFlowCommunity={this.props.selectedPracticeFlowCommunity}
                    setParent={dispatch.createPack.setParentCommunityName}
                    elements="communities"
                    changeIndexAction={dispatch.createPack.changeCommunityIndex}
                    setUniqueId={this.props.setUniqueId}
                    showResourecePaneFlag={this.props.showResourecePaneFlag}
                    collapsedResourcePaneIndexTemp={this.props.collapsedResourcePaneIndexTemp}
                />
            </div>
        );
    }
}
export default CommunityTree;
